import { render, staticRenderFns } from "./NCLDC2023.vue?vue&type=template&id=756d3cc8&scoped=true"
import script from "./NCLDC2023.vue?vue&type=script&lang=js"
export * from "./NCLDC2023.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756d3cc8",
  null
  
)

export default component.exports